import { ROUTE_PATH } from './paths';
import WrongUserRole from '../components/account-login/wrong-user-role';
import InvitationExpired from '../containers/onboarding/invitation-expired';
import InvitationRevoked from '../containers/onboarding/invitation-revoked';

export const tokenErrorRoutes = [
  {
    path: ROUTE_PATH.REQUESTNEWINVITE,
    component: InvitationExpired,
  },
];

export const publicRoutes = [
  {
    path: '/notify-message',
    component: WrongUserRole,
  },
  {
    path: ROUTE_PATH.INVITEREVOKE,
    component: InvitationRevoked,
  },
];
